<template>
    <b-button @click="executeServerAction" v-bind="$attrs">
        <slot />
    </b-button>
</template>

<script>
import { mapMutations } from "vuex";
import { fileDownload } from "../../filesystem/fileDownload";

export default {
    name: "ODoServerActionButton",
    props: {
        uri: { type: String, required: true }, //eg '/ocom_project/generate_doc/'
        method: { type: String, default: "post" },
        request: {}, // what is sent to the URL ie json data
        form: { type: Object, default: null }, // Form Data to Post - If this is NOT null it will send FormData.

        filename: { type: String, default: null }, // the Download filename

        successMessage: { type: String, default: null },
        errorMessage: {
            type: String,
            default:
                "Error talking to server. Please try again later. Contact support@ocom.com.au if it still fails",
        },
    },
    methods: {
        ...mapMutations(["showMessage"]),

        executeServerAction() {
            var vm = this;

            var root_url = process.env.VUE_APP_ROOT_API;

            var options = {};

            var expectDownload = false;

            if (this.filename) {
                expectDownload = true;
                options.responseType = "blob"; // expect a file back 'arraybuffer'
            }
            var request = {
                method: this.method.toUpperCase(),
                url: root_url + vm.uri,
                data: this.request,
                ...options,
            };

            if (this.form) {
                // We have form data to send it as form NOT a json body
                request.headers = { "Content-Type": "multipart/form-data" };
                var bodyFormData = new FormData();

                for (var key in this.form) {
                    bodyFormData.append(key, this.form[key]);
                }

                request.data = bodyFormData;
            }

            this.axios(request).then(
                function (response, status, headers) {
                    if (expectDownload || response.data instanceof Blob) {
                        fileDownload(
                            response.data,
                            vm.filename || "file",
                            response.headers["content-type"]
                        );
                    }

                    if (vm.successMessage) {
                        vm.showMessage({
                            message: vm.successMessage,
                            type: "success",
                            show: true,
                        });
                    }

                    vm.$emit("success", response.data);
                },
                function (error) {
                    if (vm.errorMessage) {
                        vm.showMessage({
                            message: vm.errorMessage,
                            type: "danger",
                            show: true,
                        });
                    }

                    vm.$emit("error", error);
                }
            );
        },
    },
};
</script>

<style scoped></style>
